const layerColour = {
    1:'#115E6E', // Blue
    2:'#AB3933', // Red
    3:'#FCAF17', // Yellow
    4:'#F26522', // Orange
    5:'#bf1fdb', // Purple
    6:'#dbb21f' // Yellow
  }

  export default layerColour